import CareerFormSectionImplementation from '../implementation/sections/CareerFormSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiCareerFormSectionDTO,
  CareerFormSectionDTO,
} from '@lib/strapi/dtos/components/sections/careerFormSection.dto';

const CareerFormSection = (props: ComponentProps<CareerFormSectionDTO>) => {
  return <CareerFormSectionImplementation {...props}></CareerFormSectionImplementation>;
};

export default CareerFormSection;
